<template>
  <div class="border">
    <div class="collapse_question" :id="id">
      <div
          class="right_collapse"
          @click="$emit('click', question, questionKey)"
      >
        <p>{{ question.question }}</p>
        <i class="fa-solid" :class="!question.collapse ? 'fa-plus' : 'fa-minus'"></i>
      </div>
    </div>
    <div v-if="question.collapse" class="collapse_paragraph">
      <span class="faq-answer" v-html="question.answer"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "collapse",
  props: ["question", "questionKey"],
  data() {
    return {
      id: null,
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/abstracts/_color.scss";
@import "../assets/scss/abstracts/_variables.scss";

.border {
  border-top: 1px solid #0c2e3c;
}

.collapse_question {

  p {
    margin-bottom: 0;
  }

  .right_collapse {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 10px;


    cursor: pointer;

    i {
      font-size: 20px;
      color: #f8bc6a;
      cursor: pointer;
    }
  }
}

.collapse_paragraph {
  font-size: 15px;
  margin-left: 15px;
  padding: 13px 0px;
}

span.faq-answer :deep * {
  color: $blue-darker;
  font-family: "Gotham", sans-serif, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.7;
}

span.faq-answer :deep a {
  color: $blue;
  font-weight: 600;
}

span.faq-answer :deep strong {
  font-weight: 700;
}

span.faq-answer :deep em {
  font-style: italic !important;
}

div.collapse_paragraph :deep ul.faq-ul {
  margin-left: 26px;
  margin-bottom: 20px;
}

</style>
